import { STANDARDS } from "@/data/site";

export const Standards = () => (
  <section id="standards" className="py-16 bg-slate-900/40 border-b border-slate-800" data-testid="standards-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-xs text-slate-300">
        {STANDARDS.map((s) => (
          <div key={s.title} className="p-6 rounded-2xl bg-slate-900/80 border border-slate-800">
            <div className="w-8 h-8 rounded-full bg-rose-500/10 text-rose-400 flex items-center justify-center font-bold mb-3">&bull;</div>
            <h4 className="text-sm font-bold text-white mb-1">{s.title}</h4>
            <p className="text-slate-400 leading-relaxed">{s.desc}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);
